import { Delete, Get, Patch, Post } from "./apiHelper";
import { IAttendancePunch, IAttendancePunchForm } from "../interfaces/AttendanceInterface";
import { ApiResponse } from "../interfaces/Api";

const punchRoot = "/api/attendancePunches";

// get punches
export async function getAttendancePunches({
  resourceCentreId,
  employeeIds,
  serviceProviderIds,
  fromDate,
  toDate,
  dutyType
}: {
  resourceCentreId: number | string;
  employeeIds?: number[];
  serviceProviderIds?: number[];
  fromDate?: string;
  toDate?: string;
  dutyType?: string;
}): Promise<ApiResponse<Array<IAttendancePunch>>> {
  const queryParams = new URLSearchParams();
  queryParams.append("resourceCentreId", resourceCentreId.toString());

  if (fromDate) queryParams.append("fromDate", fromDate);
  if (toDate) queryParams.append("toDate", toDate);
  if (employeeIds?.length) queryParams.append("employeeIds", employeeIds.join(","));
  if (serviceProviderIds?.length)
    queryParams.append("serviceProviderIds", serviceProviderIds.join(","));
  if (dutyType) queryParams.append("dutyType", dutyType);

  const response = await Get(`${punchRoot}?${queryParams.toString()}`, true);
  return response.data as ApiResponse<Array<IAttendancePunch>>;
}

// post punch
export async function postAttendancePunch(
  data: Partial<IAttendancePunchForm>
): Promise<ApiResponse<IAttendancePunch>> {
  const response = await Post(`${punchRoot}`, data, true);
  return response.data as ApiResponse<IAttendancePunch>;
}

// patch punch
export async function patchAttendancePunch({
  id,
  data
}: {
  id: number | string;
  data: Partial<IAttendancePunchForm>;
}): Promise<ApiResponse<IAttendancePunch>> {
  const response = await Patch(`${punchRoot}/${id}`, data, true);
  return response.data as ApiResponse<IAttendancePunch>;
}

// delete punch
export async function deleteAttendancePunch(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${punchRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
